import React from 'react'
import { connect } from 'react-redux'
import { render, createEnhancer } from 'react-universal-interface'
import { getCourseDetails } from 'store/actions/courses'
import { withIdle } from 'libreact/lib/IdleSensor'

const idleProps = {
  ms: 3 * 1000,
  events: ['visibilitychange'],
}

const mapStateToProps = state => {
  return {
    pending: state.course.get('pending'),
    dateLoaded: state.course.get('dateLoaded'),
    errors: state.course.get('errors').toJS(),
  }
}
const CourseLoader = withIdle(connect(mapStateToProps)(class CourseLoaderInner extends React.PureComponent {
  static propTypes = {
    // Router-provided
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    // hoc-mapped
    idle: PropTypes.bool,
    // state-mapped
    dispatch: PropTypes.func.isRequired,
    pending: PropTypes.bool,
    dateLoaded: PropTypes.instanceOf(Date),
    errors: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string,
        date: PropTypes.instanceOf(Date),
      }),
    ])),
  }

  state = {
    course: undefined,
  }


  componentDidMount() {
    this.fetch()
  }

  componentDidUpdate(prevProps) {
    this.fetch(prevProps)
  }

  fetch = (prevProps) => {
    const {
      match,
      pending,
      dateLoaded,
      errors,
      idle,
    } = this.props
    return new Promise((resolve, reject) => {
      if(!match) {
        return reject(new Error('No course provided and not rendered as a Route.'))
      }
      if(pending || (errors && errors.length)) {
        return resolve()
      }
      if(
        !dateLoaded
        || (!idle && (prevProps && prevProps.idle))
      ) {
        return resolve(this.dispatchFetch())
      }
      return setTimeout(() => {
        const {
          course
        } = this.state
        if(!course) {
          resolve(this.dispatchFetch())
        }
      }, 10)
    })
  }

  dispatchFetch = () => {
    const {
      dispatch,
      match: {
        params: {
          courseId,
        }
      },
    } = this.props
    return dispatch(getCourseDetails(courseId))
      .then(action => action.value)
      .then(course => {
        this.setState({ course })
      })
  }

  render() {
    const {
      course,
    } = this.state
    if(!course) {
      return <div>...</div>
    }
    return render(this.props, this.state)
  }
}), '', idleProps)

export default CourseLoader

export const withCourse = createEnhancer(CourseLoader, 'course')
